import { EUsernameField } from "../enum/e-username-field";
import { FieldConfigModel } from "../../../utils/typescript/model/field/field-config.model";
import { AValidator } from "./a-validator";

export class UsernameValidator extends AValidator {
  protected formElement: HTMLFormElement;
  protected elements: Map<EUsernameField, unknown> = new Map();
  protected ruleset: FieldConfigModel[];

  constructor(formElement: HTMLFormElement, ruleset: FieldConfigModel[]) {
    super();

    this.formElement = formElement;
    this.ruleset = ruleset;
    this.buildElementList();
  }

  getValidationFunctions() {
    return [
      // need to bind, because these methods used as callback
      this.validationNoEmptyStrings.bind(this),
      this.validationMaxLength.bind(this),
    ];
  }

  protected validationNoEmptyStrings(
    setFieldHintCb: (
      errorNumber: Array<number>,
      element: Array<HTMLElement>,
    ) => void,
  ) {
    const usernameElement = this.elements.get(
      EUsernameField.USERNAME_INPUT,
    ) as HTMLInputElement;

    if (usernameElement.value === "") {
      setFieldHintCb([1], [usernameElement]);
    }
  }

  protected validationMaxLength(
    setFieldHintCb: (
      errorNumber: Array<number>,
      element: Array<HTMLElement>,
    ) => void,
  ) {
    const usernameElement = this.elements.get(
      EUsernameField.USERNAME_INPUT,
    ) as HTMLInputElement;
    const maxLengthRule = this.ruleset
      .find((field) => field.fieldName === "username")
      ?.rules.find((rule) => rule.ruleShortName === "max-length");

    if (maxLengthRule && usernameElement.value.match(maxLengthRule.regex)) {
      setFieldHintCb([4], [usernameElement]);
    }
  }

  protected buildElementList() {
    const list = new Map();
    list.set(
      EUsernameField.USERNAME_CONTAINER,
      this.formElement.querySelector(".username-container"),
    ); // main element

    // username input
    list.set(
      EUsernameField.USERNAME_INPUT,
      list.get(EUsernameField.USERNAME_CONTAINER).querySelector("#username"),
    );

    // errors
    list.set(
      EUsernameField.ERROR_LIST_ELEMENTS,
      list
        .get(EUsernameField.USERNAME_CONTAINER)
        .querySelectorAll(".hint-list"),
    );

    this.elements = list;
  }
}
